import { ResultCardProps } from "./ResultCard.type"
import "./ResultCard.css"

function ResultCard({ planName, price, habitacionesPrice, mesasPrice, onContratar, loading, error, btnLabel = "Contratar plan"  }: ResultCardProps) {
    return (
        <div className="result-card">
            <p className="result-card__plan">{planName}</p>
            <p className="result-card__label">Total estimado mensual</p>
            <div className="result-card__price">
                <span className="result-card__amount">{price}</span>
                <span className="result-card__currency">USD /mes</span>
            </div>
            <div className="result-card__breakdown">
                <div className="result-card__row">
                    <span>Habitaciones</span>
                    <span>{habitacionesPrice} USD /mes</span>
                </div>
                <div className="result-card__row">
                    <span>Mesas</span>
                    <span>{mesasPrice} USD /mes</span>
                </div>
            </div>
            <button
                type="button"
                onClick={onContratar}
                disabled={loading}
                className="result-card__btn"
            >
                {btnLabel}
            </button>
            {error && <p className="result-card__error">{error}</p>}
        </div>
    )
}

export default ResultCard
